// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cln{background-color:#fff1e5}.mangaed{display:block;padding:5px 10px;font-size:1.4rem;background-color:red;color:#fff}.mangaed a{display:inline-block;padding:2px 10px;font-weight:700;color:#000;background-color:#fff;border:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
